$shm_hitalama_map_widget_tools $mol_view
	widget $shm_hitalama_map_widget
		settings_widget_enabled? => settings_widget_enabled?
	Map_page $shm_hitalama_map_page
	copy_code_template \#value('{ref}')
	sub /
		<= Copy_code $mol_button_copy
			title <= copy_code_title \
			- <= ref_str \
			text <= copy_code \
		<= Up $mol_button_minor 
			hint @ \Поднять
			sub /
				<= Up_icon $mol_icon_arrow_up
			click? <=> z_inc? null
		<= Down $mol_button_minor
			hint @ \Опустить
			sub /
				<= Down_icon $mol_icon_arrow_down
			click? <=> z_dec? null
		^ code_widget_tool_visible / <= Code_widget $mol_button_minor
			hint \Code
			sub /
				<= Code_widget_icon $mol_icon_code_braces
			click? <=> code_widget_open? null
		^ preview_reload_visible / <= Preview_reload $mol_button_minor
			hint \Обновить
			sub /
				<= Preview_reload_icon $mol_icon_refresh
			click? <=> preview_reload? null
		^ settings_check_visible / <= Settings_widget_enabled $mol_check_icon
			hint \Настройки
			Icon <= Settings_widget_enabled_icon $mol_icon_cog_outline
			checked? <=> settings_widget_enabled?
		^ settings_tool_visible / <= Settings_pop $mol_pick
			hint @ \Options
			trigger_content /
				<= Settings_trigger_icon $mol_icon_dots_vertical
			bubble_content <= settings_bubble_content /
				<= Settings_scroll $mol_scroll
					sub /
						<= Settings_content $mol_list
							sub /
								^ settings_content /
		^ tools_custom /
		<= Auto_height $mol_check_box
			title \Автовысота
			checked? <=> auto_height? false
		<= Lock $mol_check_icon
			Icon <= Lock_icon $mol_icon_lock
			checked? <=> locked? false
		<= Fullscreen $mol_link_iconed
			sub /
				<= Fullscreen_icon $mol_icon_arrow_expand_all
			uri <= fullscreen_uri \
		<= Delete $mol_button_minor
			hint @ \Delete
			sub /
				<= Delete_icon $mol_icon_trash_can
			click? <=> delete? null
	- Add_code $mol_button_minor
		hint \Код
		sub /
			<= Add_code_icon $mol_icon_code_braces
		click? <=> add_code_widget? null
